export const testimonialsData = [
  {
    id: 1,
    testimonialNum: 'testimonial-1',
    blockquoteClass: 'blockquote emphasized',
    mediaImg: '/images/homepage/testimonials/gastonTestimonial.jpg',
    quoteText:
      '"I highly recommend Short Stays International short-term rental management services! As a Realtor, my clients and I appreciate their efficient and professional approach to managing our properties. They have streamlined the rental process, making it easy and stress-free. Their attention to detail and commitment to providing top-notch customer service has resulted in increased bookings and overall satisfaction with my rental properties. We are truly impressed with John and Mai and would highly recommend them to any property owner looking for top-quality short-term rental management services."',
    quoterName: 'Gaston, Realtor & Investor',
    imgAlt: '',
  },
  {
    id: 2,
    testimonialNum: 'testimonial-2',
    blockquoteClass: 'blockquote emphasized',
    mediaImg: '',
    quoteText:
      '"Great location right off the highway Shopping is amazing every major retailer is less than a 5 minute drive ! Quiet neighborhood, beautiful parks . Thank you Andy your reason why we extended our stay an extra three weeks on a scale of 1 to 10 our stay was a 15."',
    quoterName: 'Jeanie, a guest in January 2023',
    imgAlt: '',
  },
  {
    id: 3,
    testimonialNum: 'testimonial-3',
    blockquoteClass: 'blockquote',
    mediaImg: '',
    quoteText:
      '"Mai, John and their team are efficient, reliable, hardworking and are always on top of all communications. While 99% of the time we get great guests, even the 1% that gave us issues, they are able to work with the airbnb aircover team to remove a retaliation review + get back money for any damages created by the guests. Regardless of the situation, we feel they will always try their best to find the best solutions. We highly recommend using their services."',
    quoterName: 'Trang, Homeowner',
    imgAlt: '',
  },
  {
    id: 4,
    testimonialNum: 'testimonial-4',
    blockquoteClass: 'blockquote',
    mediaImg: '',
    quoteText:
      '"Mai spends a lot of time explaining to us as new airbnb hosts on how the whole entire short term rental process works even before we were clients. Never hesitated to answer any of our questions. She’s always providing value and we appreciate all the knowledge we’ve gained from her on short-term rental."',
    quoterName: 'Jack, Airbnb Host',
    imgAlt: '',
  },
];
